import type { FaireProductEntity } from "../../entity_types/product";

export const p_gmbr8f3d6q: FaireProductEntity = {
  token: "p_gmbr8f3d6q",
  type: "product",
  name: "Stay Wild Moon Child Tee",
  brandToken: "b_d849rxmheb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a481103ae38cc58b46d712ce944f18f910234e267e3e1b1dad868f38973efd93.jpeg",
  galleryImageUrls: [],
  priceDollars: 16.63,
  description:
    "Let your boho babes channel their inner mystic with this dreamy “Stay Wild Moon Child” design. Featuring the triple moon symbol wrapped around a rose-toned full moon and delicate greenery, this graphic is perfect for free spirits, moon lovers, and all things witchy and wild. It’s an easy favorite for crystal girls, astrology addicts, and earthy souls who love a little cosmic charm in their closet. A beautiful balance of feminine energy and bold vibes—this tee is full of magic and meaning.\nColor: Heather Military Green\nUnisex sizing\n52% Airlume combed and ring-spun cotton, 48% poly\nShoulder-to-shoulder neck tape\nSet-in self neckband\nDouble needle stitching detail",
  tags: [],
  msrpDollars: 33.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:43.940Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
